import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false, publicData } = props;

  // More detailed debugging
  // console.log('SectionTextMaybe props:', JSON.stringify(props, null, 2));

  // Check if instructions_url exists anywhere in the props or publicData
  const hasInstructionsUrl =
    (publicData && publicData.instructions_url) ||
    props.instructions_url ||
    (props.listing && props.listing.instructions_url) ||
    (props.listing &&
      props.listing.attributes &&
      props.listing.attributes.publicData &&
      props.listing.attributes.publicData.instructions_url);

  // If instructions_url is found anywhere, don't render this section
  if (hasInstructionsUrl) {
    return null;
  }

  const textClass = showAsIngress ? css.ingress : css.text;
  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  return text ? (
    <section className={css.sectionText}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      <p className={textClass}>{content}</p>
    </section>
  ) : null;
};

export default SectionTextMaybe;
